// ============================================================================
// CASE GROUP ENDPOINTS — Phase A
// ============================================================================
// Backend: CaseGroupController → /api/v1/CaseGroup.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const CASE_GROUP_BASE_PATH = '/CaseGroup';

export const caseGroupEndpoints = {
  list: () => buildEndpoint(CASE_GROUP_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${CASE_GROUP_BASE_PATH}/:id`, { id }),
  create: () => buildEndpoint(CASE_GROUP_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${CASE_GROUP_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${CASE_GROUP_BASE_PATH}/:id`, { id }),
  candidates: () => buildEndpoint(`${CASE_GROUP_BASE_PATH}/candidates`),
  addMembers: (id: ID) => buildEndpointWithParams(`${CASE_GROUP_BASE_PATH}/:id/members`, { id }),
  removeMember: (memberId: ID) => buildEndpointWithParams(`${CASE_GROUP_BASE_PATH}/members/:memberId`, { memberId }),
  bulkSaveStage: (id: ID) => buildEndpointWithParams(`${CASE_GROUP_BASE_PATH}/:id/stages/bulk-save`, { id }),
  byCase: (caseId: ID) => buildEndpointWithParams(`${CASE_GROUP_BASE_PATH}/by-case/:caseId`, { caseId }),
  preSaleLetters: (id: ID) => buildEndpointWithParams(`${CASE_GROUP_BASE_PATH}/:id/letters/pre-sale`, { id }),
} as const;

export default caseGroupEndpoints;
